import * as React from 'react';
import AmCharts from "@amcharts/amcharts3-react";
import * as moment from 'moment';
import { _ } from "@src/services/i18n";
import { classNames, css, mixin, vars, defaultProps, formatters } from '@src/services/theme';
import { Proto, Props, State } from '@src/components/Proto';
import { Box, FastSearch, LastState, BatteryCycleLastState, BatteryCycleCharge, BatteryCycleTemp, Stats } from '@src/components';

// typing
interface LocalProps extends Props {
    id?: any;
    onSearch?: Function;
    getSearch?: string;
    getCharge?: string;
    getTemperature?: string;
    getState?: string;
}

// style
const style = css`
.cycle-graphs {
    ${mixin.row}
    padding: ${vars.gutter/2}px 0;
}
`;

// component
export class SingleCycle extends Proto<LocalProps, State> {

	// render
	render() {
        const { cpt, id, onSearch, getSearch, getState, getCharge, getTemperature } = this.props;

        let cid;
        try {
            cid = this.state.data.data.cycleid;
        } catch(e) {
            cid = '...';
        }

        const toolbar = () => (
            <FastSearch id="qc" placeholder={_('singlecycle_search', 'BatteryCycle')} get={getSearch} searchID={"cycleid"} onChange={onSearch}  />
        );

		return (
            <Box
                title={`Single Cycle (#${cid})`}
                toolbar={toolbar}
                collapsed={false}
            >
                <div className={style}>
                    {/*<BatteryCycleLastState {...this.props} />*/}
                    <div className="cycle-graphs">
                        <BatteryCycleCharge cpt={"BatteryCycleCharge"} get={getCharge} />
                        <BatteryCycleTemp cpt={"BatteryCycleTemp"} get={getTemperature} />
                    </div>

                    <Stats {...this.props} />
                </div>
            </Box>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/BatteryCycle/SingleCycle.tsx